module.exports = __webpack_public_path__ + "static/mobile-8671c6763c99086217dd16bb119c0995.jpg";